import React from "react";
import { useDispatch } from "react-redux";
import { openPrescriptionModal } from "../../../../../../redux/actions/modals";
import PrescriptionZoomComponent from "./../../../modals/PrescriptionZoomComponent";
import { getVendorType } from "../../../../../../services/auth";

const PrescriptionItem = ({prescription, partialOffer , price}) => {
    const dispatch = useDispatch();

    const { url, description, tag, partialOfferDescription } = prescription;
    const vendor_type = getVendorType()
    const renderPartialItemsDescriptions = () => {
        if(partialOffer !== null && tag === "PRESCRIPTION") {
            return(
                <>
                <div className="partial-order-existence-list">
                    <p>لیست اقلام ناموجود:</p>
                    <div className="list-items">
                        {partialOfferDescription?.split('\n').map((line,index) => {
                            return <span>{line}<br/></span>
                        })}
                    </div>
                </div> 
                </>
            )
        }
    }
    return (
        <div className="prescription-item-holder">
            <div className="prescription-title">
                <div className="title">نسخه/ عکس سفارش</div> <div className="count">برای {price.count} نفر</div>
            </div>
            <div className="top-holder">
                <div className="image-holder">
                    <img src={url} width={100} height={100} alt="prescription-img" />
                </div>
                <div className="descriptions-holder">
                    <div className="title">توضیحات نسخه</div>
                    <div className="description">{description}</div>
                </div>
            </div>
            <div className="buttons-holder">
                <button className="btn btn-outline btn-primary btn-sm"
                        onClick={() => {
                            dispatch(openPrescriptionModal(url))
                        }}
                >مشاهده</button>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                        let popup = window.open();
                        popup.document.write('<img src="' + url + "\" alt='' />");
                        popup.focus(); //required for IE
                        popup.print();
                    }}
                >
                    چاپ
                </button>
            </div>
            <div>
                {vendor_type ==='DRUG' && renderPartialItemsDescriptions() }
            </div>
            <PrescriptionZoomComponent />
        </div>
    );
};

export default PrescriptionItem;
